import styled from 'styled-components';
import { InnerContainer, GameMainLayout } from './MainLayout';
import useQuery from '../helpers/useQuery';
import { ContentPaper, ContentHeader } from '../components/Student/styled';
import Highscores from '../components/Highscores';

const ErrorMessage = styled.div`
    font-style: italic;
`;

const HighscoresView = () => {
    const query = useQuery();

    const gameToken = query.get('game');
    return (
        <GameMainLayout>
            <InnerContainer>
                <ContentPaper>
                    <ContentHeader>Highscores</ContentHeader>
                    {gameToken && <Highscores gameToken={gameToken} />}
                    {!gameToken && (
                        <ErrorMessage>Geen gametoken in url</ErrorMessage>
                    )}
                </ContentPaper>
            </InnerContainer>
        </GameMainLayout>
    );
};
export default HighscoresView;
